import { Input, Divider, Select, Col, Button, Table, Form, Modal } from "antd";
import Typography from "../../Typography";
import { COLORS } from "../../../constants/Colors";
import MyInput from "../../Input";
import { useState, useRef, useEffect, useCallback } from "react";
import { Option } from "antd/es/mentions";
import useIsDesktop from "../../../utils/hooks/useIsDesktop";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "antd/es/form/Form";
import MyButton from "../../Button";
import LoadMoreSelect from "../../LoadMoreSelect";
import {
  createConvertUoM,
  createUoM,
  getConvertUoM,
  getListItemNew,
} from "../../../controllers/queue/createModal";
import { useDebounce } from "../../../utils/hooks/useDebounce";
import { errorNotification, successNotification } from "../../Notification";
import "./model.css";

const ModalAddUom = (props) => {
  const {
    visible,
    onCancel,
    setTrigger,
    tableData,
    recordItem,
    uomaster,
    addNameUoM,
    uomList,
  } = props;

  const isDesktop = useIsDesktop();
  const intl = useIntl();
  const [form] = Form.useForm();
  const product = Form.useWatch("product", form);
  const [eventProduct, setEventProduct] = useState(false);
  const [productList, setProductList] = useState([]);
  const [scrollProduct, setScrollProduct] = useState(10);
  const [searchProduct, setSearchProduct] = useState("");
  const debounch = useDebounce(searchProduct, 500);
  const { getFieldValue, getFieldsValue, setFieldsValue } = form;
  let isEdit = _.size(recordItem) > 0 ? "edit" : "create";
  const fieldLeft = {
    borderTopRightRadius: "0px",
    borderBottomRightRadius: "0px",
  };
  const fieldMiddle = { borderRadius: "0px" };
  const fieldRight = {
    color: COLORS.Black,
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  };
  const dataLeft = [{ id: "กล่อง" }, { id: "ตะกร้า" }];
  const dataRight = [{ id: "กิโลกรัม" }, { id: "กรัม" }];

  useEffect(() => {
    if (uomaster?.length > 0) {
      form.setFieldsValue({ uom: _.get(uomaster, "[0].unit", "") });
    }
  }, [uomaster]);

  const handleOnkeyPressNumber = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  };

  const layout = {
    wrapperCol: { span: 24 }, // กำหนดความกว้างของพื้นที่ที่บรรจุ Component
  };
  console.log("ROVCRGG", uomaster, addNameUoM);

  const handleZeroPrice = (rule, value, callback) => {
    if (value) {
      const parsValue = parseInt(value || 0);

      if (parsValue === 0) {
        callback(
          intl.formatMessage({
            id: "validateQtyThanZero",
            defaultMessage: "Qty must be greater than 0",
          })
        );
      } else {
        callback();
      }
    } else {
      callback();
    }
  };

  const handleSaveitem = () => {
    console.log("getFieldsValue", getFieldsValue("product"));

    form
      .validateFields()
      .then(async (values) => {
        let tempData = tableData;

        const nameNewUOM = [
          _.get(values, "baseleft"),
          _.get(values, "baseqty"),
          _.get(values, "baseright")
        ].join(" ");
        const checkUOM = _.filter(uomList,(i) => {return i.name === nameNewUOM})
        console.log('NEWBASEUOM',nameNewUOM,checkUOM,uomList);
        

        if (_.size(checkUOM) > 0) {
          errorNotification(
            intl.formatMessage({
              id: "UOMfalseNotification",
              defaultMessage: "Have already this UOM",
            })
          );
          return;
        }
        
        try {
          const body = {
            name: nameNewUOM,
            description: "",
            uomCategoryId: _.get(uomaster, "[0].uomCategoryId"),
          };
          const response = await createUoM(body);

          console.log("ROVCR", response);

          if (response.status === 200) {
            const body = {
              categoryId: _.get(uomaster, "[0].uomCategoryId"),
              baseQty: 1,
              baseUomId: _.get(response, "data.data.uomId"),
              altQty: parseFloat(_.get(values, "qty")),
              altUomId: _.get(uomaster, "[0].uomId"),
              description: "",
            };
            if (_.get(response, "data.status.code") === 200) {
              const response = await createConvertUoM(body);
              setTrigger((current) => !current);
              successNotification(_.get(response, "data.status.message"));
              form.resetFields();
              onCancel();
            } else {
              errorNotification(_.get(response, "data.status.message"));
            }
          } else {
            errorNotification(_.get(response, "data.status.message"));
          }
        } catch (error) {
          errorNotification(_.get(error, "response.data.status.message"));
        }
      })
      .catch((info) => {
        errorNotification(
          intl.formatMessage({
            id: "saveErrorNotification",
            defaultMessage: "Failed",
          })
        );
      });
  };

  return (
    <Modal
      className={isDesktop ? "custom-modal" : undefined}
      style={{ marginTop: isDesktop ? "-50px" : null }}
      maskClosable={false}
      title={
        <Typography
          color={isDesktop ? COLORS.Purple : COLORS.GreenBrown}
          isBold
          size="16px"
          className={isDesktop ? "pb-0" : "text-center pb-2"}
        >
          <FormattedMessage
            id="ModalAddUomCreateTitle"
            defaultMessage="เพิ่มหน่วย"
          />
        </Typography>
      }
      open={visible}
      onOk={() => {}}
      onCancel={() => {
        onCancel();
        form.resetFields();
      }}
      width={772}
      centered={isDesktop ? true : false}
      footer={[
        isDesktop ? (
          <>
            <MyButton
              onClick={() => {
                onCancel();
                form.resetFields();
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
            </MyButton>
            <MyButton
              isPrimary
              onClick={() => {
                handleSaveitem();
              }}
              style={{
                width: isDesktop ? "25%" : "48%",
              }}
            >
              <FormattedMessage id="btnSave" defaultMessage="Save" />
            </MyButton>
          </>
        ) : (
          <div style={{ marginTop: "-12px" }}>
            <MyButton
              isPrimary
              onClick={() => {
                handleSaveitem();
              }}
              style={{
                width: isDesktop ? "25%" : "100%",
                marginBottom: "10px",
              }}
            >
              <FormattedMessage id="btnSave" defaultMessage="Save" />
            </MyButton>
            <MyButton
              onClick={() => {
                onCancel();
                form.resetFields();
              }}
              style={{
                width: isDesktop ? "25%" : "100%",
                marginLeft: "0px",
              }}
            >
              <FormattedMessage id="btnCancel" defaultMessage="Cancel" />
            </MyButton>
          </div>
        ),
      ]}
    >
      <div
        className="d-flex flex-column py-2 m-2"
        // style={{ height: "calc(100vh - 765px)" }}
        style={{ height: "80px" }}
      >
        <Form {...layout} form={form}>
          <div
            className={`d-flex ${isDesktop ? "flex-row" : "flex-column"} pb-3`}
          >
            <Col className="px-0" span={isDesktop ? 4 : 24}>
              <div className="d-flex align-items-center pb-1">
                <Typography color={COLORS.Purple} className="pb-1">
                  <FormattedMessage id="addUomTitle" defaultMessage="หน่วย" />
                </Typography>
              </div>
              <Form.Item
                name="baseleft"
                initialValue={_.get(dataLeft, "[0].id")}
              >
                {/* <MyInput
                  label={
                    <FormattedMessage id="addUomTitle" defaultMessage="หน่วย" />
                  }
                  placeHolder={intl.formatMessage({
                    id: "ModalAddUomCreateNewUomPH",
                    defaultMessage: "ระบุหน่วย",
                  })}
                  className="w-100 leftSelect"
                  style={fieldLeft}
                /> */}

                <Select
                  className="w-100 leftSelect"
                  placeholder={intl.formatMessage({
                    id: "ModalAddProductCreateUnitPH",
                    defaultMessage: "ระบุหน่วย",
                  })}
                  onChange={(e) => {}}
                  onSelect={(e) => {}}
                  optionLabelProp="label"
                  defaultValue={_.get(dataLeft, "[0].id")}
                  style={fieldLeft}
                >
                  {dataLeft &&
                    _.map(dataLeft, (item, index) => {
                      return (
                        <Option
                          label={_.get(item, "id")}
                          key={_.get(item, "id")}
                          value={_.get(item, "id")}
                        >
                          {_.get(item, "id")}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="px-0" span={isDesktop ? 4 : 24}>
              <Form.Item
                name="baseqty"
                rules={[
                  {
                    required: getFieldValue("type") === "TAS-DO" ? false : true,
                    message: (
                      <FormattedMessage
                        id="ModalAddProductCreateQtyVD"
                        defaultMessage="กรุณาระบุจำนวน"
                      />
                    ),
                  },
                  {
                    validator: handleZeroPrice,
                  },
                ]}
              >
                <MyInput
                  label={<div style={{ marginTop: "16px" }}></div>}
                  placeHolder={intl.formatMessage({
                    id: "ModalAddProductCreateQtyPH",
                    defaultMessage: "ระบุจำนวน",
                  })}
                  className="w-100"
                  onKeyPress={handleOnkeyPressNumber}
                  style={{ borderRadius: "0px" }}
                />
              </Form.Item>
            </Col>
            <Col className="px-0" span={isDesktop ? 4 : 24}>
              <div>
                <div style={{ marginTop: "23.5px" }}> </div>

                <Form.Item
                  name="baseright"
                  initialValue={_.get(dataRight, "[0].id")}
                >
                  <Select
                    className="w-100 RightSelect"
                    placeholder={intl.formatMessage({
                      id: "ModalAddProductCreateUnitPH",
                      defaultMessage: "ระบุหน่วย",
                    })}
                    onChange={(e) => {}}
                    onSelect={(e) => {}}
                    optionLabelProp="label"
                    // defaultValue={_.get(dataRight, "[0].id")}
                    style={fieldLeft}
                  >
                    {dataRight &&
                      _.map(dataRight, (item, index) => {
                        return (
                          <Option
                            label={_.get(item, "id")}
                            key={_.get(item, "id")}
                            value={_.get(item, "id")}
                          >
                            {_.get(item, "id")}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </div>
            </Col>

            <div className="mr-3" />
            <Col className="px-0" span={isDesktop ? 6 : 24}>
              <Form.Item
                name="qty"
                rules={[
                  {
                    required: getFieldValue("type") === "TAS-DO" ? false : true,
                    message: (
                      <FormattedMessage
                        id="ModalAddProductCreateQtyVD"
                        defaultMessage="กรุณาระบุจำนวน"
                      />
                    ),
                  },
                  {
                    validator: handleZeroPrice,
                  },
                ]}
              >
                <MyInput
                  label={<div style={{ marginTop: "16px" }}></div>}
                  placeHolder={intl.formatMessage({
                    id: "ModalAddProductCreateQtyPH",
                    defaultMessage: "ระบุจำนวน",
                  })}
                  className="w-100"
                  onKeyPress={handleOnkeyPressNumber}
                  style={fieldLeft}
                />
              </Form.Item>
            </Col>
            <Col className="px-0" span={isDesktop ? 6 : 24}>
              <div className="w-100">
                <div style={{ marginTop: "23.5px" }} />

                <Form.Item
                  name="uom"
                  // initialValue={_.get(uomaster, "[0].unit")}
                >
                  <MyInput
                    disabled={true}
                    className="w-100"
                    style={fieldRight}
                  />
                  {/* <Select
                    className="w-100"
                    placeholder={intl.formatMessage({
                      id: "ModalAddProductCreateUnitPH",
                      defaultMessage: "ระบุหน่วย",
                    })}
                    onChange={(e) => {}}
                    onSelect={(e) => {}}
                    optionLabelProp="label"
                    defaultValue={_.get(uomaster, "[0].uomId")}
                    disabled={true}
                    style={{color: COLORS.Black }}
                  >
                    {uomaster &&
                      _.map(uomaster, (item, index) => {
                        return (
                          <Option
                            label={_.get(item, "unit")}
                            key={_.get(item, "uomId")}
                            value={_.get(item, "uomId")}
                          >
                            <Typography isBold color={COLORS.Black}>{_.get(item, "unit")}</Typography>
                          </Option>
                        );
                      })}
                  </Select> */}
                </Form.Item>
              </div>
            </Col>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default ModalAddUom;
